import React from 'react';
import { HelpElement } from '../elements/Help';

function Help() {
  return <HelpElement>Help</HelpElement>;
}

export default Help;
